/* eslint-disable @typescript-eslint/no-restricted-imports */
import * as proceduralTexture from "procedural-textures/legacy/legacy-cloud";
export { proceduralTexture };
export default proceduralTexture;
